import { render, staticRenderFns } from "./customer-promise.vue?vue&type=template&id=5965c9f0&scoped=true&"
import script from "./customer-promise.vue?vue&type=script&lang=js&"
export * from "./customer-promise.vue?vue&type=script&lang=js&"
import style0 from "./customer-promise.vue?vue&type=style&index=0&id=5965c9f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5965c9f0",
  null
  
)

export default component.exports